import React from 'react';
import { DisplayTemplatesPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const DisplayTemplatesPage = props => <DisplayTemplatesPageComponent {...props} notificationApi={notificationApi} />;
